export default {
  'projectSettings.detail.title': '專案詳情',
  'projectSettings.detail.subtitle': '維護目前專案的基本資訊',
  'projectSettings.detail.basicInfo': '基本資訊',
  'projectSettings.detail.unsaved': '有未儲存的修改',
  'projectSettings.detail.refresh': '重新整理',
  'projectSettings.detail.edit': '修改專案',
  'projectSettings.detail.noContext': '目前頁面未識別到專案內容',
  'projectSettings.detail.loadError': '專案詳情載入失敗',
  'projectSettings.detail.loadErrorHint': '請檢查網路連線後重試。',
  'projectSettings.detail.retry': '重試',
  'projectSettings.detail.logoPreview': '預覽',
  'projectSettings.detail.priority': '專案優先級',
  'projectSettings.detail.cnName': '專案名稱',
  'projectSettings.detail.name': '英文名稱',
  'projectSettings.detail.identifier': '專案標識',
  'projectSettings.detail.prefix': '專案簡稱',
  'projectSettings.detail.group': '專案分組',
  'projectSettings.detail.group.none': '未分組',
  'projectSettings.detail.group.loadError': '專案分組載入失敗，請稍後重試',
  'projectSettings.detail.tags': '專案標籤',
  'projectSettings.detail.status': '專案狀態',
  'projectSettings.detail.status.initiation': '立項',
  'projectSettings.detail.status.requirements': '需求分析',
  'projectSettings.detail.status.design': '設計中',
  'projectSettings.detail.status.development': '開發中',
  'projectSettings.detail.status.testing': '測試中',
  'projectSettings.detail.status.launched': '已上線',
  'projectSettings.detail.status.maintenance': '維護中',
  'projectSettings.detail.priority.low': '低',
  'projectSettings.detail.priority.medium': '中',
  'projectSettings.detail.priority.high': '高',
  'projectSettings.detail.priority.urgent': '緊急',
  'projectSettings.detail.logo': '專案 Logo 網址',
  'projectSettings.detail.updatedAt': '最近更新',
  'projectSettings.detail.description': '專案描述',
  'projectSettings.detail.empty': '未填寫',
  'projectSettings.detail.editTitle': '修改專案詳情',
  'projectSettings.detail.save': '儲存',
  'projectSettings.detail.cancel': '取消',
  'projectSettings.detail.cnNameRequired': '請輸入專案名稱',
  'projectSettings.detail.identifierRequired': '請輸入專案標識',
  'projectSettings.detail.identifierExists': '專案標識已存在',
  'projectSettings.detail.saveSuccess': '專案詳情已更新',
  'projectSettings.detail.saveError': '專案詳情更新失敗，請稍後重試',
  'projectSettings.detail.previewHint':
    '目前為預覽狀態，點擊「修改專案」即可直接編輯。',
  'projectSettings.detail.editingHint': '正在編輯專案詳情，完成後請儲存修改。',
  'projectSettings.detail.discardTitle': '放棄未儲存的修改？',
  'projectSettings.detail.discardContent':
    '目前的修改尚未儲存，離開編輯狀態後將無法復原。',
  'projectSettings.detail.discard': '放棄修改',
  'projectSettings.detail.continueEditing': '繼續編輯',
};
